<script>
  import { getStyleValue } from "../../Common/tools";
  import TextEditor from "../../Common/TextEditor.svelte";
  import {External} from "../../external";

  export let data, meta, globalStyle, onChange;
  let timer,
    image = External.resources + "/images/marketing/placeholders/timer_zeros.gif";

  let debounce = () => {
    clearTimeout(timer);
    timer = setTimeout(getImage, 750);
  };

  let getImage = () => {
    image = External.Website.countdownGeneratorUrlBase + "?endDate=" + data.endDate + "&color=" + (data.theme === "light" ? "black" : "white");
  };

  let change = (prop, val) => {
    onChange();
    debounce();
    data = Object.assign({}, data, { [prop]: val });
  };

  $: debounce(data.endDate);
</script>

<th class="column column-st" width={getStyleValue(globalStyle.width, 600)} align="center">
  <table class="component-center" align="center" bgcolor={data.style.backgroundColor} cellpadding="0" cellspacing="0" border="0">
    <tbody>
      <tr>
        <td>
          <table width="400" border="0" align="center" cellpadding="0" cellspacing="0" style="text-align: center; width: 400px; max-width: 400px;">
            <tbody>
              <tr>
                <td>
                  <img alt="" src={image} style="border: 0; width: 100%;" />
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
      <tr>
        <td>
          <table width="400" align="center" style="text-align: center;">
            <tr>
              <td style="width: 25%">
                <TextEditor bind:data={data.days} meta={meta} onChange={(val) => change("days", val)} emailEditor={true} />
              </td>
              <td style="width: 25%">
                <TextEditor bind:data={data.hours} meta={meta} onChange={(val) => change("hours", val)} emailEditor={true} />
              </td>
              <td style="width: 25%">
                <TextEditor bind:data={data.minutes} meta={meta} onChange={(val) => change("minutes", val)} emailEditor={true} />
              </td>
              <td style="width: 25%">
                <TextEditor bind:data={data.seconds} meta={meta} onChange={(val) => change("seconds", val)} emailEditor={true} />
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </tbody>
  </table>
</th>
